import { j as s, B as n } from "./chunks/baseIcon-BOu_HqxP.js";
const o = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.75 3C6.46979 3 3 6.46979 3 10.75C3 15.0302 6.46979 18.5 10.75 18.5C12.62 18.5 14.3353 17.8377 15.6742 16.7348L19.7197 20.7803C20.0126 21.0732 20.4874 21.0732 20.7803 20.7803C21.0732 20.4874 21.0732 20.0126 20.7803 19.7197L16.7348 15.6742C17.8377 14.3353 18.5 12.62 18.5 10.75C18.5 6.46979 15.0302 3 10.75 3ZM4.5 10.75C4.5 7.29822 7.29822 4.5 10.75 4.5C14.2018 4.5 17 7.29822 17 10.75C17 14.2018 14.2018 17 10.75 17C7.29822 17 4.5 14.2018 4.5 10.75Z" fill="#314351"/></svg>';
function r(e) {
  return /* @__PURE__ */ s.jsx(n, { svg: o, ...e });
}
r.displayName = "SearchLarge";
export {
  r as default
};
